import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import {
  // privateRoutes,
  publicRoutes,
  // superAdminRoutes,
  // AdminRoutes,
  // StaffRoutes,
  // employeeRoutes,
  protectedRoutes
} from "./routes";
import Login from "./components/auth/Login";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { useSelector } from "react-redux";
import ProtectedRoute from "./components/common/ProtectedRoute";
// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/xava-theme.scss";
import FallBackSpinner from "./components/common/FallBackSpinner";
import { RouteErrorBoundary } from "./components/common/ErrorBoundary";
import Cookies from "universal-cookie";
const cookies = new Cookies();
const root = ReactDOM.createRoot(document.getElementById("root"));
const UserInfo = cookies?.get("MMCL_user");
root.render(
  <React.Suspense fallback={<FallBackSpinner />}>
    <Provider store={store}>
      <BrowserRouter>
        <RouteErrorBoundary>
        <Routes>
          {protectedRoutes.map(({ path, Component, allowedRoles }) => (
  <Route
    key={path}
    path={path}
    element={
      <ProtectedRoute allowedRoles={allowedRoles}>
        <App>
          <Component />
        </App>
      </ProtectedRoute>
    }
  />
))}


          {/* {AdminRoutes.map(({ path, Component }) => (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <App>
                    <Component />
                  </App>
                </ProtectedRoute>
              }
            />
          ))}

          {StaffRoutes.map(({ path, Component }) => (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedRoute allowedRoles={["staff","admin"]}>
                  <App>
                    <Component />
                  </App>
                </ProtectedRoute>
              }
            />
          ))}

          {employeeRoutes.map(({ path, Component }) => (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedRoute allowedRoles={["employee","admin"]}>
                  <App>
                    <Component />
                  </App>
                </ProtectedRoute>
              }
            />
          ))} */}

          {publicRoutes.map(({ path, Component }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}

          {/* Fallback Route */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        </RouteErrorBoundary>
      </BrowserRouter>
    </Provider>
  </React.Suspense>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
